import { render, staticRenderFns } from "./DeliveryIncome.vue?vue&type=template&id=5e21e592&lang=pug&"
import script from "./DeliveryIncome.vue?vue&type=script&lang=ts&"
export * from "./DeliveryIncome.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryIncome.vue?vue&type=style&index=0&id=5e21e592&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports